import { render, staticRenderFns } from "./ServizioClienti.vue?vue&type=template&id=497bbf40&scoped=true"
import script from "./ServizioClienti.vue?vue&type=script&lang=js"
export * from "./ServizioClienti.vue?vue&type=script&lang=js"
import style0 from "./ServizioClienti.vue?vue&type=style&index=0&id=497bbf40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bbf40",
  null
  
)

export default component.exports